export var LABELED_CONTROL_POSITIONS = {
  left: 'left',
  right: 'right'
};